import React from "react";
import { ArrowDownIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { planningQuestions } from "../data/content";
export function FromTo() {
  return <section className="bg-white px-5 py-16 md:py-24" data-id="element-134" data-mp="1hzh3oyuza04z">
      <div className="mx-auto max-w-2xl" data-id="element-135" data-mp="1hxxn175etn2o">
        <div className="text-center" data-id="element-136" data-mp="1mykc8ta62ohp">
          <p className="text-sm font-bold uppercase tracking-wider text-ink/45" data-id="element-137" data-mp="1mzmyup0gi4rt">From…</p>
          <p className="mt-2 font-display text-2xl font-bold italic text-ink/55 md:text-3xl" data-id="element-138" data-mp="1rygdwlve63u3">
            “Should I place an implant in this case?”
          </p>
          <ArrowDownIcon className="mx-auto my-5 h-7 w-7 text-plum-600" aria-hidden data-id="element-139" data-mp="1wueyrzhih3pr" />
          <p className="text-sm font-bold uppercase tracking-wider text-plum-600" data-id="element-140" data-mp="21pkshkh5nmoe">To…</p>
          <p className="mt-2 font-display text-[28px] font-extrabold leading-tight text-plum-900 md:text-4xl" data-id="element-141" data-mp="25oa2d32zim3a">
            “I know exactly what I need to review before making the decision.”
          </p>
        </div>

        <div className="mt-14 space-y-5 text-[17px] leading-relaxed text-ink/80" data-id="element-142" data-mp="2fkwn7rvb9d5b">
          <p data-id="element-143" data-mp="2hwqa1kstsb13">When I started dealing with more complex implant cases, I realized something:</p>
          <p className="font-display text-2xl font-bold leading-snug text-ink" data-id="element-144" data-mp="2cv0upsyklb77">
            The most important moment isn't always the surgery.
          </p>
          <p data-id="element-145" data-mp="23wfgga04sic8">Many of the decisions that influence the case have already been made before I ever pick up the surgical handpiece.</p>
        </div>

        <ul className="mt-8 divide-y divide-plum-100 rounded-2xl bg-plum-50 px-5" data-id="element-146" data-mp="30l4wrvw412w3">
          {planningQuestions.map(q => <li key={q} className="flex items-start gap-3 py-3.5 text-[16px] font-medium text-plum-900" data-id="element-147" data-mp="2wmp3xbdcl0ar">
              <div className="mt-0.5 h-5 w-5 shrink-0 text-plum-600" aria-hidden data-id="element-148" data-mp="2rr9tktejtmj3" />
              {q}
            </li>)}
        </ul>

        <div className="mt-10 space-y-4 text-[17px] leading-relaxed text-ink/80" data-id="element-149" data-mp="3kafax5g7jfs3">
          <p data-id="element-150" data-mp="3fjgwkbes4rrh">
            That's why I created <strong className="text-plum-800" data-id="element-151" data-mp="3fi5po2q1f3w5">IMPLANT DECISION SYSTEM™</strong>.
          </p>
          <p data-id="element-152" data-mp="2b2zi94ske9f">It's not another implantology course.</p>
          <p className="font-display text-2xl font-bold leading-snug text-ink" data-id="element-153" data-mp="2ce6ehtja24r">
            It's a structured decision system for analyzing and planning implant cases{" "}
            <em className="text-plum-600" data-id="element-154" data-mp="3pmvmxvahxju1">before surgery.</em>
          </p>
        </div>

        <div className="mt-10" data-id="element-155" data-mp="3tn62nzo3bom3">
          <CtaButton label="I want a system for my implant cases" data-id="element-156" data-mp="3tmctks1nsn0s" />
        </div>
      </div>
    </section>;
}